import { BaseModel } from '../../global/models';


export interface HolidayYear extends BaseModel {
  holidays: Holiday[];
}

export interface Holiday {
  date: Date;
  name?: string;
  postalCodes: string[];
  type?: HolidayType;
}

export enum HolidayType {
  LOCAL = 'local',
  REGIONAL = 'regional',
  NATIONAL = 'national',
}
